import s from "styled-components";

export const Wrap = s.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

const ICON_WIDTH = 40;
const ICON_GAP = 7;
export const Container = s.div`
  // display: flex;
  margin-bottom: 10px;
  padding: 10px;
  background-color: ${({ isActive }) =>
    isActive ? "var(--color-cta)" : "var(--color-danger)"};
  color: white;
  // justify-content: flex-start;
  // align-items: center;
  border-radius: var(--root-br);
  box-shadow: ${({ theme }) => theme.shadow[0]};
  img {
    display: block;
    margin-right: ${ICON_GAP}px;
    width: ${ICON_WIDTH}px;
  }
`;

export const IconAndTitle = s.div`
  display: flex;
  align-items: center;
`;

export const Title = s.div`
  font-weight: 700;
`;
export const Tip = s.div`
  padding-inline-start: ${ICON_WIDTH + ICON_GAP}px;
  font-weight: 400;
`;
